import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import axios from 'axios';

export default function SwitchBetweenTechnologies() {

    const { id } = useParams();
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(true);
    const [keyResponse, setKeyResponse] = useState(null);

    useEffect(() => {
        fetchKeyStatus()
    }, [id]);

    const fetchKeyStatus = async () => {
        if (!id) { return }

        const data = {
            id: id
        }

        const request = await axios.post("https://ger.wa.48.defaultbot.com/v5/adminKeyStatus", data);
        console.log({ response: request.data });
        setKeyResponse(request.data.key);
        setLoading(false);
    }

    return (
        <div className="content-block t-container">
            <div className="t-content">
                <div className="page-header"><h1>Протоколы ключа</h1></div>
            </div>
            <div className="t-content">

                {isLoading === true && <>Загрузка...</>}
                {isLoading === false && keyResponse === null && <>ОШИБКА</>}
                {isLoading === false && keyResponse !== null && <>
                    {keyResponse.is_vless_active &&
                        <button
                            className="t-button"
                            onClick={(e) => {
                                navigate(`/vless-key/${id}`)
                            }}
                        >
                            Открыть Vless
                        </button>}
                    {keyResponse.is_shadowsocks_active && <button
                        className="t-button"
                        onClick={(e) => {
                            navigate(`/key/${id}`)
                        }}
                    >
                        Открыть Outline
                    </button>}
                </>}

            </div>

        </div>
    )
}